import { SearchX } from 'lucide-react';

/**
 * Silent filter nudge — when a filtered list returns 0 rows, show a small
 * "Reset to Today" link so the screen is never blank. `onReset` should set the
 * page's date range back to today and clear any branch selection (the same
 * reset primitive used by the Inter-Branch / Dashboard modules).
 */
export const FilterEmptyNudge = ({ show, onReset, label = 'No results for the current filter' }) => {
  if (!show) return null;
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-10 text-center" data-testid="filter-empty-nudge">
      <SearchX size={22} className="text-muted-foreground/60" />
      <p className="text-sm text-muted-foreground">{label}</p>
      <button
        type="button"
        onClick={onReset}
        className="text-sm font-medium text-primary hover:underline"
        data-testid="reset-to-today-link"
      >
        Reset to Today
      </button>
    </div>
  );
};

export default FilterEmptyNudge;
